module.exports = __webpack_public_path__ + "static/media/txxw.927bda1a.svg";